// extracted by mini-css-extract-plugin
export default {"backButtonContainer":"backButton_backButtonContainer__fOPDV","backSingleBtn":"backButton_backSingleBtn__mnkj2"};